import React, { useState } from 'react';
import { IconButton, Tooltip, Zoom } from '@mui/material';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { useFavorites, useAuthentication } from '../../store/AppContext';
import { DESIGN_TOKENS } from '../../styles/theme';
import { useI18n } from '../../i18n';
import { LoginRequiredModal } from './index';

interface FavoriteButtonProps {
  listingDocumentId: string;
  size?: 'small' | 'medium' | 'large';
  color?: string;
}

export function FavoriteButton({
  listingDocumentId,
  size = 'medium',
  color = DESIGN_TOKENS.colors.accent,
}: FavoriteButtonProps) {
  const { t } = useI18n();
  const { isFavorite, toggleFavorite } = useFavorites();
  const { isAuthenticated } = useAuthentication();
  const [isAnimating, setIsAnimating] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  const active = isFavorite(listingDocumentId);

  const handleToggle = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (!isAuthenticated) {
      setIsLoginModalOpen(true);
      return;
    }

    setIsAnimating(true);
    await toggleFavorite(listingDocumentId);
    setTimeout(() => setIsAnimating(false), 300);
  };

  return (
    <>
      <Tooltip title={active ? t('listings.removeSavedListing') : t('listings.saveListing')} TransitionComponent={Zoom}>
        <IconButton
          onClick={handleToggle}
          size={size}
          sx={{
            color: active ? color : 'inherit',
            transition: 'transform 0.2s ease-in-out',
            transform: isAnimating ? 'scale(1.3)' : 'scale(1)',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              transform: 'scale(1.1)',
            },
          }}
        >
          {active ? (
            <BookmarkIcon fontSize={size} sx={{ color }} />
          ) : (
            <BookmarkBorderIcon fontSize={size} />
          )}
        </IconButton>
      </Tooltip>

      <LoginRequiredModal
        open={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        title="Zaloguj się, aby dodać do ulubionych"
        description="Ta opcja jest dostępna wyłącznie dla zalogowanych użytkowników. Zaloguj się, aby zapisywać ogłoszenia w ulubionych."
      />
    </>
  );
}
